import { render, staticRenderFns } from "./DetailPPage.vue?vue&type=template&id=3b1e47fe&scoped=true&"
import script from "./DetailPPage.vue?vue&type=script&lang=js&"
export * from "./DetailPPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPPage.vue?vue&type=style&index=0&id=3b1e47fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e47fe",
  null
  
)

export default component.exports